<template>
<!-- 基本信息组件 -->
<div class="scientific-service-wrap">
  <div class="search-wrap">
    <el-row :gutter="20">
      <el-col :span="8">
        <el-date-picker
          v-model="timeArr"
          type="daterange"
          size="mini"
          :clearable="false"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-col>
      <el-col :span="16">
        <div class="search-btns">
          <el-button size="mini" @click="handlePreWeek" class="week-btn">上一周</el-button>
          <el-button size="mini" @click="handleNextWeek" class="week-btn">下一周</el-button>
          <el-button type="primary" size="mini" class="btn-bg" @click="handleSearch">搜索</el-button>
        </div>
      </el-col>
    </el-row>
  </div>
  <div class="info-content">
    <el-scrollbar>
      <ul class="tab-wrap">
        <li v-for="item in tabList"
            :key="item.conceptId"
            :class="activeTabId === item.conceptId? 'active-bg':''"
            @click="changeTab(item)">{{item.conceptName}} {{item.until}}</li>
      </ul>
    </el-scrollbar>  
    <div style="width:800px">
      <table style="width: max-content;">
        <div v-for="(item,index) in scienceList" :key="index" style="margin-bottom:16px">
            <tr class="time-style">
              <td v-for="(it,key) in item.timearr" :key="key">{{it}}</td>
            </tr>
            <tr>
              <td v-for="(it1,key1) in item.itemList" :class="key1 == 0? 'td-item-style':''" :key="key1">
                <span :title="it1" class="show-over-dot">{{it1}}</span>
              </td>
            </tr>
        </div>
      </table>
    </div>
  </div>
</div>
</template>

<script>
import {getAdminPatientDataForAdmin} from "@/api/InfoMonitor"
import moment from 'moment'
export default {
  name:"baseInfo",
  props:{
    userData:{
      type:Object,
      default:()=>{}
    }
  },
  data() {
    return {
      allScienceData: [],
      activeTabId: '',
      scienceList: [],
      // '血压（收缩压）mmHg','血压（舒张压）mmHg','空腹血糖 mmol/L','餐后血糖 mmol/L','体温 ℃','心率  次/分','脉搏 次/分'
      tabList:[],
      timeArr: [
        moment().subtract('days', 6).format('YYYY-MM-DD 00:00:00'),
        moment().format('YYYY-MM-DD 23:59:59')
      ],
    }
  },
  watch: {
    'userData.patientId': {
      async handler(newVal,oldVal) {
        this.tabList = []
        await this.getTerminologyData()
        await this.getBaseInfoTableData()
      },
      deep: true
    }
  },
  async created() {
    await this.getTerminologyData()
    await this.getBaseInfoTableData()

    // var a=this.scienceList.map(v => v.timearr);
    // // var cArr = this.scienceList.map(v => v.timearr);
    // var max=a[0].length;
    // var b = 0
    // for (var i = 1; i < a.length; i++) {
    //     if (max<a[i].length) {
    //         max=a[i].length
    //         b=i
    //     }
    // }
    // // alert(b);
    // // alert(a[b]);

    // a[b].forEach((v,i) => {
    //   this.scienceList.forEach(item => {
    //     if (item.timearr[i] == undefined) {
    //       // item.timearr[i] = '1'
    //       // item.itemList[i] = '1'
    //       this.$set(item.timearr, i, '')
    //       this.$set(item.itemList, i, '')
    //     }
    //   })
    // })
  },
  methods: {
    // 获取术语list
    async getTerminologyData() {
      let res = await getAdminPatientDataForAdmin({
        patientId: this.userData.patientId // this.userData.patientId
      })
      if (res.code === 0) {
        this.tabList = res.data
        if (this.tabList) {
          this.activeTabId = this.tabList[0].conceptId
        }
      }
    },

    changeTab(item) {
      this.scienceList = []
      this.activeTabId = item.conceptId
      // this.getBaseInfoTableData()
      this.getScienceList()
    },
    // 筛选匹配表格数据
    getScienceList() {
      let selectTabData = this.allScienceData.filter(v => v.conceptId === this.activeTabId)[0]
      if (selectTabData) {
        selectTabData.researchDataByDates.forEach(item => {
          this.scienceList.push({
            datestr: item.localDataDate,
            timearr: [''].concat(item.dataOnUnits.map(v => v.localDataTime)),
            itemList: [item.localDataDate].concat(item.dataOnUnits.map(v => v.valueStr))
          })
        })
      }
    },



    handleSearch() {
      this.getBaseInfoTableData()
    },
    async getBaseInfoTableData() {
      this.scienceList = []
      let res = await getAdminPatientDataForAdmin({
        // endTime: `${this.timeArr[1]} 23:59:59`,
        // startTime: `${this.timeArr[0]} 00:00:00`,
        endTime: this.timeArr[1],
        startTime: this.timeArr[0],
        patientId: this.userData.patientId, //this.userData.patientId,
        conceptId: this.activeTabId
      })
      if (res.code === 0) {
        this.allScienceData = []
        // res.data = [
        //   {
        //     conceptId: 0,
        //     conceptName: "",
        //     researchDataByDates: [
        //       {
        //         dataOUnits: [
        //           {
        //             localDataTime: "09:00",
        //             valueStr: "120"
        //           },
        //           {
        //             localDataTime: "11:00",
        //             valueStr: "130"
        //           }
        //         ],
        //         localDataDate: "2022-02-24"
        //       },
        //       {
        //         dataOUnits: [
        //           {
        //             localDataTime: "15:00",
        //             valueStr: "160"
        //           }
        //         ],
        //         localDataDate: "2022-02-23"
        //       }
        //     ]
        //   }
        // ]
        if (res.data) {
          this.allScienceData = res.data
          this.getScienceList()
        }
      }
    },
    handlePreWeek() {
      this.timeArr = [
        moment(this.timeArr[0]).subtract('days', 6).format('YYYY-MM-DD 00:00:00'),
        moment(this.timeArr[0]).format('YYYY-MM-DD 23:59:59')
      ]
      this.getBaseInfoTableData()
    },
    handleNextWeek() {
      this.timeArr = [
        moment(this.timeArr[1]).format('YYYY-MM-DD 00:00:00'),
        moment(this.timeArr[1]).add('days', 6).format('YYYY-MM-DD 23:59:59')
      ]
      this.getBaseInfoTableData()
    }
  }
}
</script>

<style lang="less" scoped>
.scientific-service-wrap {
  height: 100%;
  // .base-title {
  //   margin-bottom:14px;
  //   font-size: 14px;
  //   font-weight: 400;
  //   color: #333333;
  // }
  .search-wrap {
    background-color: #FFFFFF;
    padding: 15px;
  }
  .info-content {
    height: calc(100% - 80px);
    // margin-top: 16px;
    padding: 17px 16px;
    background-color: #FFFFFF;
    overflow: auto;
    width: 100%;
    /deep/.el-scrollbar__view {
      width: 800px;
    }
  }
  .btn-bg {
    background-color: #1A7BFC;
  }
  .tab-wrap {
    padding: 10px 0px;
    padding-top: 0;
    background-color: #fff;
    display: flex;
    // max-width: 800px;
    // overflow: auto;
    li {
      padding: 5px 10px;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      white-space: nowrap;
    }
  }
  .active-bg {
    background-color: #1A7BFC;
    color: #fff !important;
    border-radius: 4px;
  }
}
/deep/.el-date-editor--daterange.el-input, .el-date-editor--daterange.el-input__inner, .el-date-editor--timerange.el-input, .el-date-editor--timerange.el-input__inner {
  width: 100%;
}
/deep/.el-date-editor .el-range-separator {
  width: 30px;
}
.week-btn {
  color: #1A7BFC;
  border: 1px solid #1A7BFC;
}
tr {
  border-bottom: 1px solid #E9E9E9;
}
td {
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #333333;
}
.time-style {
  background: #FAFAFA;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
}
.td-item-style {
  background: #FAFAFA;
  font-size: 14px;
  font-weight: 600;
  color: #333333;
}
.show-over-dot {
  display: block;
  width: 100px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
